var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9 8C2.9 4.90721 5.40721 2.4 8.5 2.4C11.5928 2.4 14.1 4.9072 14.1 8C14.1 11.0928 11.5928 13.6 8.5 13.6C5.40721 13.6 2.9 11.0928 2.9 8ZM1.5 8C1.5 4.13401 4.63401 1 8.5 1C12.366 1 15.5 4.13401 15.5 8C15.5 11.866 12.366 15 8.5 15C4.63401 15 1.5 11.866 1.5 8ZM9.22437 12.0896L7.76937 12.0896L7.76937 6.99879H9.22437L9.22437 12.0896ZM8.49906 4.00007C8.09728 4.00007 7.77157 4.32568 7.77157 4.72733C7.77157 5.12899 8.09728 5.45459 8.49906 5.45459C8.90085 5.45459 9.22656 5.12899 9.22656 4.72733C9.22656 4.32568 8.90085 4.00007 8.49906 4.00007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.4f6ae2b5931ea38bdedc8729508282fe.svg";
export { ForwardRef as ReactComponent };